"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRenderApp = exports.reactAppRenderer = exports.getInitialData = exports.setInitialData = void 0;
var React = require("react");
var ReactDOM = require("react-dom");
var create_app_container_1 = require("create-app-container");
var create_use_router_1 = require("create-use-router");
var queryString = require("query-string");
var component_1 = require("@loadable/component");
var createElement = React.createElement, useEffect = React.useEffect, useState = React.useState, Fragment = React.Fragment, useLayoutEffect = React.useLayoutEffect;
var useRouter = create_use_router_1.createUseRouter({ useState: useState, useLayoutEffect: useLayoutEffect });
var __initialData__;
function setInitialData(initialData) {
    __initialData__ = initialData;
}
exports.setInitialData = setInitialData;
function getInitialData() {
    return __initialData__;
}
exports.getInitialData = getInitialData;
function reactAppRenderer(options) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, appConfig, setAppConfig, loadStaticModules;
        return __generator(this, function (_b) {
            _a = options || {}, appConfig = _a.appConfig, setAppConfig = _a.setAppConfig, loadStaticModules = _a.loadStaticModules;
            setAppConfig(appConfig);
            loadStaticModules(appConfig);
            if (process.env.__IS_SERVER__)
                return [2 /*return*/];
            renderInBrowser(options);
            return [2 /*return*/];
        });
    });
}
exports.reactAppRenderer = reactAppRenderer;
function getRenderApp(runtime, options) {
    var _a, _b;
    var ErrorBoundary = options.ErrorBoundary, _c = options.appConfig, appConfig = _c === void 0 ? {} : _c;
    var _d = appConfig.app, ErrorBoundaryFallback = _d.ErrorBoundaryFallback, onErrorBoundaryHander = _d.onErrorBoundaryHander, onErrorBoundaryHandler = _d.onErrorBoundaryHandler, errorBoundary = _d.errorBoundary;
    var AppProvider = (_a = runtime === null || runtime === void 0 ? void 0 : runtime.composeAppProvider) === null || _a === void 0 ? void 0 : _a.call(runtime);
    var AppRouter = (_b = runtime === null || runtime === void 0 ? void 0 : runtime.getAppRouter) === null || _b === void 0 ? void 0 : _b.call(runtime);
    if (process.env.NODE_ENV === 'development') {
        if (onErrorBoundaryHandler) {
            console.error('Please use onErrorBoundaryHandler instead of onErrorBoundaryHander');
        }
    }
    function App() {
        var appRouter = React.createElement(AppRouter, null);
        var rootApp = AppProvider ? React.createElement(AppProvider, null, appRouter) : appRouter;
        if (errorBoundary) {
            return (React.createElement(ErrorBoundary, { Fallback: ErrorBoundaryFallback, onError: onErrorBoundaryHandler || onErrorBoundaryHander }, rootApp));
        }
        return rootApp;
    }
    return App;
}
exports.getRenderApp = getRenderApp;
function renderInBrowser(options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var appConfig, _b, staticConfig, _c, buildConfig, createBaseApp, emitLifeCycles, context, _d, href, origin_1, pathname, search, path, query, ssrError, initialContext, _e, _f, runtime, history, modifiedAppConfig, isMobile;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    appConfig = options.appConfig, _b = options.staticConfig, staticConfig = _b === void 0 ? {} : _b, _c = options.buildConfig, buildConfig = _c === void 0 ? {} : _c, createBaseApp = options.createBaseApp, emitLifeCycles = options.emitLifeCycles;
                    context = {};
                    if (!window.__ICE_APP_DATA__) return [3 /*break*/, 1];
                    context.initialData = window.__ICE_APP_DATA__;
                    context.pageInitialProps = window.__ICE_PAGE_PROPS__;
                    return [3 /*break*/, 3];
                case 1:
                    if (!((_a = appConfig === null || appConfig === void 0 ? void 0 : appConfig.app) === null || _a === void 0 ? void 0 : _a.getInitialData)) return [3 /*break*/, 3];
                    _d = window.location, href = _d.href, origin_1 = _d.origin, pathname = _d.pathname, search = _d.search;
                    path = href.replace(origin_1, '');
                    query = queryString.parse(search);
                    ssrError = window.__ICE_SSR_ERROR__;
                    initialContext = {
                        pathname: pathname,
                        path: path,
                        query: query,
                        ssrError: ssrError
                    };
                    _e = context;
                    return [4 /*yield*/, appConfig.app.getInitialData(initialContext)];
                case 2:
                    _e.initialData = _g.sent();
                    _g.label = 3;
                case 3:
                    _f = createBaseApp(appConfig, buildConfig, context), runtime = _f.runtime, history = _f.history, modifiedAppConfig = _f.appConfig;
                    // set InitialData, can get the return value through getInitialData method
                    setInitialData(context.initialData);
                    options.appConfig = modifiedAppConfig;
                    // Emit app launch cycle
                    emitLifeCycles();
                    isMobile = Object.keys(staticConfig).length;
                    if (isMobile) {
                        return [2 /*return*/, _renderMobile({ runtime: runtime, history: history }, options)];
                    }
                    else {
                        return [2 /*return*/, _render({ runtime: runtime }, options)];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function _render(_a, options) {
    var _b;
    var runtime = _a.runtime;
    var _c = options.appConfig, appConfig = _c === void 0 ? {} : _c;
    var _d = appConfig.app, rootId = _d.rootId, mountNode = _d.mountNode;
    var App = getRenderApp(runtime, options);
    var appMountNode = _getAppMountNode(mountNode, rootId);
    if (runtime === null || runtime === void 0 ? void 0 : runtime.modifyDOMRender) {
        return (_b = runtime === null || runtime === void 0 ? void 0 : runtime.modifyDOMRender) === null || _b === void 0 ? void 0 : _b.call(runtime, { App: App, appMountNode: appMountNode });
    }
    if (window.__ICE_SSR_ENABLED__) {
        component_1.loadableReady(function () {
            ReactDOM.hydrate(React.createElement(App, null), appMountNode);
        });
    }
    else {
        ReactDOM.render(React.createElement(App, null), appMountNode);
    }
}
function _renderMobile(_a, options) {
    var runtime = _a.runtime, history = _a.history;
    var staticConfig = options.staticConfig, _b = options.appConfig, appConfig = _b === void 0 ? {} : _b;
    var routes = staticConfig.routes;
    var _c = appConfig.app, rootId = _c.rootId, mountNode = _c.mountNode;
    var appMountNode = _getAppMountNode(mountNode, rootId);
    return _matchInitialComponent(history.location.pathname, routes)
        .then(function (InitialComponent) {
        var _a;
        var App = function () {
            var component = useRouter({ routes: routes, history: history, InitialComponent: InitialComponent }).component;
            var AppNavigation = create_app_container_1.createNavigation({ createElement: createElement, useEffect: useEffect, useState: useState, Fragment: Fragment });
            return createElement(AppNavigation, {
                staticConfig: staticConfig,
                component: component,
                history: history,
                location: history.location,
                routes: routes
            });
        };
        var AppProvider = (_a = runtime === null || runtime === void 0 ? void 0 : runtime.composeAppProvider) === null || _a === void 0 ? void 0 : _a.call(runtime);
        var Root = function () {
            if (AppProvider) {
                return createElement(AppProvider, null, createElement(App));
            }
            return createElement(App);
        };
        var appInstance = createElement(Root);
        ReactDOM.render(appInstance, appMountNode);
    });
}
function _matchInitialComponent(fullpath, routes) {
    var initialComponent = null;
    for (var i = 0, l = routes.length; i < l; i++) {
        if (fullpath === routes[i].path || routes[i].regexp && routes[i].regexp.test(fullpath)) {
            initialComponent = routes[i].component;
            if (typeof initialComponent === 'function')
                initialComponent = initialComponent();
            break;
        }
    }
    return Promise.resolve(initialComponent);
}
function _getAppMountNode(mountNode, rootId) {
    return mountNode || document.getElementById(rootId) || document.getElementById('ice-container');
}
